import React from "react";

import { TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Column } from "../../../../common/Table/types";
import EpisodeSharedWithMeCell from "./EpisodeSharedWithMeCell";

interface Props {
  columns: Column[];
  row: Record<string, any>;
}

export default function EpisodeSharedWithMeRow({ columns, row }: Props) {
  const navigate = useNavigate();
  const handleEpisodeClick = () => {
    navigate(`/episodes-shared-with-me/${row.id}`);
  };

  return (
    <TableRow
      hover
      role="button"
      tabIndex={0}
      sx={{
        cursor: "pointer",
      }}
      onClick={handleEpisodeClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleEpisodeClick();
        }
      }}
    >
      {columns.map((column) => {
        return (
          <EpisodeSharedWithMeCell
            key={column.id}
            column={column}
            value={row[column.id]}
          />
        );
      })}
    </TableRow>
  );
}
